module.exports = __webpack_public_path__ + "static/media/transactions.152523d4.svg";